import { Space } from "antd";
import React from "react";
import TmsEntryScanService from "../../../services/tms-entry-scan.service";
import catchErrorFunction from "../../../utils/tms-catch-error/tms-catch-error";
import { EditOutlined, EyeOutlined } from "@ant-design/icons";
import { withRouter } from "../../../utils/tms-with-router/tms-with-router";
import tmsRouteMap from "../../../constants/tms-route.map";

const TmsESinnerActions = ({
  record,
  setLoading,
  setViewEntryScanData,
  settmsModalVisible,
  // eslint-disable-next-line no-unused-vars
  setUpdateFlag,
  setEditFlag,
  setProductId,
  router,
}) => {
  return (
    <Space size="middle">
      <a
        onClick={() => {
          router.navigate(
            `${tmsRouteMap.sm_entry_scan_manage_counter}?id=${record.key}`
          );
        }}
      >
        Manage Counter
      </a>
      <a
        onClick={async () => {
          setLoading(true);
          try {
            const darData = await TmsEntryScanService.viewEntryScan(
              record?.key
            );
            // console.log(darData);
            setViewEntryScanData(darData);
            settmsModalVisible(true);
          } catch (error) {
            catchErrorFunction(
              error,
              "Token Expired, redirecting to login page in 5 seconds",
              router
            );
          }
          setLoading(false);
        }}
      >
        <EyeOutlined />
      </a>
      {/* <Popconfirm
        title="Are you sure delete this darshanam?"
        onConfirm={async () => {
          setLoading(true);
          try {
            await TmsDarshanamService.deleteDarshanam(record?.key);
            notification.success({
              message: "Darshanam Deleted Successful",
            });
            setUpdateFlag(Math.Random + 1);
          } catch (error) {
            catchErrorFunction(
              error,
              "Token Expired, redirecting to login page in 5 seconds",
              router
            );
          }
          setLoading(false);
        }}
        okText="Yes"
        cancelText="No"
      >
        <a>
          <DeleteOutlined />
        </a>
      </Popconfirm> */}
      <a
        onClick={async () => {
          setLoading(true);
          try {
            const darData = await TmsEntryScanService.viewEntryScan(
              record?.key
            );
            setViewEntryScanData(darData);
            settmsModalVisible(true);
            setEditFlag(true);
            setProductId(record?.key);
          } catch (error) {
            catchErrorFunction(
              error,
              "Token Expired, redirecting to login page in 5 seconds",
              router
            );
          }
          setLoading(false);
        }}
      >
        <EditOutlined />
      </a>
    </Space>
  );
};
export default withRouter(TmsESinnerActions);
